//
import {
  CARGOS_GET_COSTO_INSCRIPCION,
  CARGOS_GET_COSTO_INSCRIPCION_SUCCESS,
  CARGOS_GET_COSTO_INSCRIPCION_FAIL,
  CARGOS_GET_COSTO_COLEGIATURA,
  CARGOS_GET_COSTO_COLEGIATURA_SUCCESS,
  CARGOS_GET_COSTO_COLEGIATURA_FAIL,
} from "./actionTypes"

export const getCargosCostoInscripcion = jsonparameters => ({
  type: CARGOS_GET_COSTO_INSCRIPCION,
  payload: { jsonparameters },
})
export const getCargosCostoInscripcionSuccess = data => ({
  type: CARGOS_GET_COSTO_INSCRIPCION_SUCCESS,
  payload: { data },
})
export const getCargosCostoInscripcionFail = error => ({
  type: CARGOS_GET_COSTO_INSCRIPCION_FAIL,
  payload: error,
})

export const getCargosCostoColegiatura = jsonparameters => ({
  type: CARGOS_GET_COSTO_COLEGIATURA,
  payload: { jsonparameters },
})
export const getCargosCostoColegiaturaSuccess = data => ({
  type: CARGOS_GET_COSTO_COLEGIATURA_SUCCESS,
  payload: { data },
})
export const getCargosCostoColegiaturaFail = error => ({
  type: CARGOS_GET_COSTO_COLEGIATURA_FAIL,
  payload: error,
})
